import Vuetify from 'vuetify'

import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader

import 'vuetify/dist/vuetify.min.css'

import { pt, en } from 'vuetify/es5/locale'
import colors from 'vuetify/es5/util/colors'

export default {
  install:(app, { theme, callback }) => {
    Vuetify.config.silent = true
    app.use(Vuetify)
    
    const redundancia = {
      primary: colors.blue.darken2,
      secondary: colors.grey.darken2,
      accent: colors.blue.accent1,
      error: colors.red.accent2,
      info: colors.blue,
      success: colors.green,
      warning: colors.amber
    }

    var theme = Object.assign(redundancia, theme)

    if (!theme.options.compact) {
      theme.options.compact = {}
    }
    if (!theme.options.grid) {
      theme.options.grid = { pageSize: [5, 10, 15, 20, -1] }
    }
    if (!theme.options.breadcrumbs) {
      theme.options.breadcrumbs = {}
    }

    const vuetify = new Vuetify({
      theme,
      breakpoint: {
        mobileBreakpoint: 540
      },
      lang: {
        locales: { pt, en },
        current: 'pt'
      },
      icons: {
        iconfont: 'mdi' || 'fa' || 'far' || 'fas' || 'md'
      }
    })

    const defaultTheme = {
      placeholder: ' ',
      placeholderSelect: 'Selecione',
      placeholderMultiSelect: 'Nenhum',
      placeholderCombobox: 'Digite ou Selecione',
      placeholderMultiCombobox: 'Nenhum',
      outlined: true,
      dense: true
    }

    theme.options = Object.assign(defaultTheme, theme.options)
    app.prototype.$theme = theme
  
    callback(vuetify)
  }
}